export const SITE = {
  brand: 'CRISTIAN CRUZ',
  whatsapp: 'https://chat.whatsapp.com/Ey3Buly2eq6D2p0MxwnilV',
  instagram: 'https://www.instagram.com/cristian_cruz_247/',
  instagramHandle: '@cristian_cruz_247',
  tagline: 'Productos. Estrategia. Ventas. Escala.',
};

export const NOTES = [
  { id: 'bergamota', name: 'BERGAMOTA', stage: 'SALIDA', index: '01' },
  { id: 'lavanda', name: 'LAVANDA', stage: 'CORAZÓN', index: '02' },
  { id: 'vainilla', name: 'VAINILLA', stage: 'CORAZÓN', index: '03' },
  { id: 'madera', name: 'MADERA', stage: 'FONDO', index: '04' },
];

export const STATS = [
  { value: 50, prefix: '$', suffix: 'K+', label: 'AL MES' },
  { value: 100, suffix: '+', label: 'ENVÍOS SEMANALES' },
  { value: 15, suffix: 'K+', label: 'COMUNIDAD' },
  { value: 'USA', label: 'ENVÍOS NACIONALES' },
];

export const VIDEO = {
  src: '/media/perfume-macro.mp4',
  poster: '/media/perfume-brand.png',
};

export const TESTIMONIAL_SLOTS = [1, 2, 3].map((n) => ({ id: `slot-${n}` }));

export const PRODUCTS = [
  { id: 'noir-absolu', name: 'Noir Absolu', image: '/media/product-1.jpg' },
  { id: 'midnight-oud', name: 'Midnight Oud', image: '/media/product-2.jpg' },
  { id: 'platino-9', name: 'Platino Nº9', image: '/media/product-3.jpg' },
];
